import type { SupplyChainGrn } from './types'

const STORAGE_KEY = 'erp.supplyChain.goodsReceiptNotes.v1'

function safeParse(json: string | null): SupplyChainGrn[] {
  if (!json) return []
  try {
    const parsed = JSON.parse(json)
    if (!Array.isArray(parsed)) return []
    return parsed as SupplyChainGrn[]
  } catch {
    return []
  }
}

function seedIfEmpty(): void {
  if (window.localStorage.getItem(STORAGE_KEY)) return
  const today = new Date().toISOString().slice(0, 10)
  const seed: SupplyChainGrn[] = [
    {
      id: 'seed-grn-1',
      code: 'GRN-00001',
      reference: '12345',
      vendor: 'shizc',
      warehouse: 'Saudi Arabia (SA)',
      purchaseOrderCode: '1',
      orderDate: today,
      grnDate: today,
      grnReference: 'GRN-00001',
      attachmentName: '',
      status: 'open',
      isBillCreated: false,
      lines: [
        {
          id: 'seed-line-1',
          itemName: 'Sample item',
          orderQuantity: 10,
          quantityReceived: 5,
          toReceive: 5,
          unitPrice: 100,
          discountPercent: 0,
          taxPercent: 15,
        },
      ],
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
  ]
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(seed))
}

export function listSupplyChainGrns(): SupplyChainGrn[] {
  seedIfEmpty()
  return safeParse(window.localStorage.getItem(STORAGE_KEY))
}

export function getSupplyChainGrn(id: string): SupplyChainGrn | undefined {
  return listSupplyChainGrns().find((r) => r.id === id)
}

export function upsertSupplyChainGrn(row: SupplyChainGrn): void {
  const all = listSupplyChainGrns()
  const idx = all.findIndex((r) => r.id === row.id)
  const next = idx >= 0 ? all.map((r, i) => (i === idx ? row : r)) : [row, ...all]
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
}

export function deleteSupplyChainGrn(id: string): void {
  const all = listSupplyChainGrns()
  const next = all.filter((r) => r.id !== id)
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
}

